// SPDX-License-Identifier: AGPL-3.0-or-later

import MediaEngine from '@app/features/voice/engine/MediaEngineFacade';
import type {
	VoiceEngine,
	VoiceEngineAudioInputDevice,
	VoiceEngineAudioOutputDevice,
	VoiceEngineCameraDevice,
	VoiceEngineConnectParams,
	VoiceEngineEventListener,
	VoiceEnginePublishCameraParams,
	VoiceEnginePublishMicrophoneParams,
	VoiceEnginePublishScreenParams,
	VoiceEngineStats,
} from '@app/features/voice/engine/native_voice_engine/VoiceEngine';

export class JsVoiceEngine implements VoiceEngine {
	readonly kind = 'js' as const;

	async connect(_params: VoiceEngineConnectParams): Promise<void> {}

	async disconnect(): Promise<void> {
		await MediaEngine.disconnectFromVoiceChannel('user');
	}

	isConnected(): boolean {
		return MediaEngine.connected;
	}

	async publishMicrophone(_params?: VoiceEnginePublishMicrophoneParams): Promise<void> {}

	async publishScreenShare(_params: VoiceEnginePublishScreenParams): Promise<void> {}

	async unpublishScreenShare(): Promise<void> {}

	async setMicEnabled(enabled: boolean): Promise<void> {
		const room = MediaEngine.room;
		if (!room) return;
		await room.localParticipant.setMicrophoneEnabled(enabled);
	}

	async publishCamera(_params: VoiceEnginePublishCameraParams): Promise<void> {}

	async listCameraDevices(): Promise<Array<VoiceEngineCameraDevice>> {
		return [];
	}

	async unpublishCamera(): Promise<void> {}

	async listAudioInputDevices(): Promise<Array<VoiceEngineAudioInputDevice>> {
		return [];
	}

	async listAudioOutputDevices(): Promise<Array<VoiceEngineAudioOutputDevice>> {
		return [];
	}

	async setAudioOutputDevice(_deviceId: string): Promise<void> {}

	async setParticipantVolume(_participantSid: string, _volume: number): Promise<void> {}

	async setRemoteTrackSubscription(_params: Parameters<VoiceEngine['setRemoteTrackSubscription']>[0]): Promise<void> {}

	async publishData(_params: Parameters<VoiceEngine['publishData']>[0]): Promise<void> {}

	async getConnectionStats(): Promise<VoiceEngineStats | null> {
		return null;
	}

	onEvent(_listener: VoiceEngineEventListener): () => void {
		return () => {};
	}
}
